var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSbIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150,
    height: 150,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "b",
    width: "154.6%",
    height: "154.6%",
    x: "-27.3%",
    y: "-23.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.70154471 0 0 0 0 0.695194598 0 0 0 0 1 0 0 0 0.5 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    width: "151.5%",
    height: "151.5%",
    x: "-25.7%",
    y: "-18.4%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.846523498 0 0 0 0 0.842972497 0 0 0 0 0.960155542 0 0 0 0.3 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M0.73842576,16.4127347 C1.93088606,19.8163514 3.44630437,24.0895052 7.61991544,26.1018625 C12.1910133,28.3129712 18.1533148,27.0210875 21.8300674,23.7913782 C27.5190968,18.7977508 29.2829443,9.30737434 24.214988,4.33859085 C17.3583413,-2.34442294 4.8871939,-0.90347573 1.08622668,5.90375765 C-0.230448238,8.26392981 -0.354662853,13.3072451 0.73842576,16.4127347 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f",
    d: "M11.9604072,4.03020714 L21.8372709,4.03020714 C22.1296832,4.03020714 22.2761758,4.38234255 22.0692533,4.58828971 L15.7435812,10.8885042 C15.5368019,11.0944514 15.6832945,11.4465868 15.9757068,11.4465868 L20.3255192,11.4465868 C20.6083372,11.4465868 20.7586961,11.7793255 20.5711055,11.9902644 L9.83304306,24.0692649 C9.6017767,24.3294086 9.17676211,24.0983599 9.27127344,23.7639097 L11.6290448,15.4277564 C11.6880427,15.2190994 11.530667,15.0121539 11.3130046,15.0121539 L7.38147641,15.0121539 C7.14433889,15.0121539 6.98538801,14.7692675 7.08118814,14.5531941 L11.6601189,4.22502973 C11.712673,4.1066529 11.8303825,4.03020714 11.9604072,4.03020714"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "-18.479%",
    y2: "80.729%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#D5D5EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ABAADA"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: 23.803,
    cy: 23.803,
    r: 23.803
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(20 20)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    fill: "#000",
    filter: "url(#b)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.768 10.768)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    fill: "#000",
    filter: "url(#e)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    fill: "#FFC878"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2B862",
    d: "M19.7603353,10.0761566 C16.6927309,10.0361747 13.8491805,11.8732278 11.229684,15.5873159 C8.6101876,19.3014039 7.6145104,22.3433099 8.24265243,24.7130338 L13.3756275,26.1963464 L22.1661393,14.7025917 L19.7603353,10.0761566 Z",
    mask: "url(#g)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSbIcon);
export default __webpack_public_path__ + "static/media/SB-icon.b28db9c0a8950fd333cc05ee4e7b706b.svg";
export { ForwardRef as ReactComponent };